export const routes = {
  home: '/',
  signIn: '/auth/sign-in',
  signUp: '/auth/sign-up',
  forgotPassword: '/auth/forgot-password',
  resetPassword: '/auth/reset-password',
  confirmationAccount: '/auth/confirmation-account',
  myProfile: '/users/profile/me',
  dashboard: '/dashboard',
};
